"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONType = exports.JSONFormat = exports.JSONRefType = void 0;
var JSONRefType;
(function (JSONRefType) {
    JSONRefType["ACTOR"] = "ACTOR";
    JSONRefType["APP"] = "APP";
    JSONRefType["CONTEXT"] = "CONTEXT";
    JSONRefType["CONTEXT_TYPE"] = "CONTEXT_TYPE";
    JSONRefType["DATA_TABLE"] = "DATA_TABLE";
    JSONRefType["DATA_TABLE_ROW"] = "DATA_TABLE_ROW";
    JSONRefType["DELAY"] = "DELAY";
    JSONRefType["DURATION"] = "DURATION";
    JSONRefType["FIELD"] = "FIELD";
    JSONRefType["FILE"] = "FILE";
    JSONRefType["GROUP"] = "GROUP";
    JSONRefType["GUEST"] = "GUEST";
    JSONRefType["HELP"] = "HELP";
    JSONRefType["LITERAL_DATETIME"] = "LITERAL_DATETIME";
    JSONRefType["NOTIFICATION"] = "NOTIFICATION";
    JSONRefType["PREDICTIVE_MODEL"] = "PREDICTIVE_MODEL";
    JSONRefType["TASK"] = "TASK";
    JSONRefType["STEP"] = "STEP";
    JSONRefType["TEAM"] = "TEAM";
    JSONRefType["UPCOMING"] = "UPCOMING";
    JSONRefType["WEBHOOK"] = "WEBHOOK";
    JSONRefType["WORKFLOW_TEMPLATE"] = "WORKFLOW_TEMPLATE";
    JSONRefType["WORKFLOW_TEMPLATE_TYPE"] = "WORKFLOW_TEMPLATE_TYPE";
})(JSONRefType = exports.JSONRefType || (exports.JSONRefType = {}));
var JSONFormat;
(function (JSONFormat) {
    JSONFormat["BINARY"] = "binary";
    JSONFormat["CODE"] = "code";
    JSONFormat["CODE_CSS"] = "code:css";
    JSONFormat["CODE_HTML"] = "code:html";
    JSONFormat["CODE_JAVASCRIPT"] = "code:javascript";
    JSONFormat["CODE_PYTHON"] = "code:python";
    JSONFormat["CONDITION"] = "CONDITION";
    JSONFormat["DATE"] = "date";
    JSONFormat["DATE_TIME"] = "date-time";
    JSONFormat["DURATION"] = "duration";
    JSONFormat["EMAIL"] = "email";
    JSONFormat["EXPRESSION"] = "expression";
    JSONFormat["HOSTNAME"] = "hostname";
    JSONFormat["IDN_EMAIL"] = "idn-email";
    JSONFormat["IDN_HOSTNAME"] = "idn-hostname";
    JSONFormat["IPV4"] = "ipv4";
    JSONFormat["IPV6"] = "ipv6";
    JSONFormat["IRI"] = "iri";
    JSONFormat["IRI_REFERENCE"] = "iri-reference";
    JSONFormat["JSON"] = "json";
    JSONFormat["JSON_POINTER"] = "json-pointer";
    JSONFormat["PASSWORD"] = "password";
    JSONFormat["REF"] = "ref";
    JSONFormat["REGEX"] = "regex";
    JSONFormat["RELATIVE_JSON_POINTER"] = "relative-json-pointer";
    JSONFormat["TIME"] = "time";
    JSONFormat["TIMEZONE"] = "timezone";
    JSONFormat["URI"] = "uri";
    JSONFormat["URI_REFERENCE"] = "uri-reference";
    JSONFormat["URI_TEMPLATE"] = "uri-template";
})(JSONFormat = exports.JSONFormat || (exports.JSONFormat = {}));
var JSONType;
(function (JSONType) {
    JSONType["ARRAY"] = "array";
    JSONType["BOOLEAN"] = "boolean";
    JSONType["INTEGER"] = "integer";
    JSONType["NULL"] = "null";
    JSONType["NUMBER"] = "number";
    JSONType["OBJECT"] = "object";
    JSONType["STRING"] = "string";
})(JSONType = exports.JSONType || (exports.JSONType = {}));
//# sourceMappingURL=type.js.map